<template>
  <div class="mt-2 lancar-notas">
    <div>
      <v-btn icon @click="btnArrowBack">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <div class="lancar-notas-header mt-2">
      <Select
        class="mt-5 lancar-notas-header-select"
        label="Período Avaliativo"
        v-model="periodoSelecionado"
        :disabled="loading"
        :options="periodosAvaliativos"
        @change="changePeriodoAvaliativo"
      />

      <v-spacer></v-spacer>
      <InformacoesPromocaoPeriodos
        class="lancar-notas-header-info"
        :valores="valoresPromocaoPeriodo"
      />
    </div>
    <div class="mb-2">
      <v-btn
        type="button"
        :loading="loadingSaveNotas"
        :disabled="loadingSaveNotas || !getExisteNotasPendenteParaSalvar([...listaNotasNormais, ...listaNotasRecuperacao, ...listaNotasRecuperacaoEspecial])"
        small
        color="teal"
        class="teste"
        @click="handleSaveNotas"
      >
        <v-icon color="#FFF"
          v-if="getExisteNotasPendenteParaSalvar([...listaNotasNormais, ...listaNotasRecuperacao, ...listaNotasRecuperacaoEspecial])"
          small
        >error</v-icon>
        <v-icon color="#FFF"
          v-if="!getExisteNotasPendenteParaSalvar([...listaNotasNormais, ...listaNotasRecuperacao, ...listaNotasRecuperacaoEspecial])"
          small
        >done</v-icon><span class="white--text font-weight-regular ms-2">Salvar Notas</span>
      </v-btn>
    </div>

    <div class="mb-2" v-if="exibirColunasEspecial()">
      <CheckBox
        label="Oportunidades Finais"
        v-model="exibirProvasEspeciais"
        @click="clickEspecial"
      />
    </div>

    <div>
      <div v-if="this.valoresPromocaoPeriodo.length <= 0 || msgError">
        <v-alert type="error" value="true" style="color: white;">
          <div
            v-if="this.valoresPromocaoPeriodo.length <= 0"
          >Configuração anual ainda não foi lançada!</div>
          <div v-else>{{ msgError }}</div>
        </v-alert>
      </div>
      <transition
        v-else
        name="router-lancar-notas"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div v-if="sumiu" class="table-overflow">
          <table class="table-siged" style="position: relative">
            <thead class="fixed">
              <tr>
                <!-- <th rowspan="2" class="headcol">Foto</th> -->
                <th rowspan="2" class="headcol">
                  <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                      </template>
                      <span class="text-caption white--text">Dê um duplo clique no nome do aluno abaixo para visualizar <br>informações de contato sobre o respectivo aluno.</span>
                  </v-tooltip>
                  Aluno
                </th>

                <!-- Notas Normais -->
                <template v-for="nota in notasNormais[0]">
                  <th
                    :key="nota.id"
                    v-if="nota.primeiroDistribuicao && (idExibirDetalhado === 0 || idExibirDetalhado === nota.identificadordistribuirnotas) && !exibirProvasEspeciais"
                    :rowspan="(idExibirDetalhado > 0)? 1 : 2"
                    :colspan="(idExibirDetalhado > 0)? atividadesDetalhado.length : 1"
                  >
                    <span :title="nota.descricaoatividadeavaliativa">
                      {{ nota.siglaatividadeavaliativa }} <br>
                      ({{ nota.valordistribuicao | formatNumber }} pts)<br>
                    </span>
                    <v-menu>
                        <template v-slot:activator="{ on }">
                            <v-btn dark icon v-if="nota.indicadetalhamento == 'S'">
                              <v-icon v-on="on" small color="#000">{{ idExibirDetalhado > 0 ? 'remove' : 'add' }}</v-icon>
                            </v-btn>
                        </template>
                          <v-list class="text-center p-4" v-if="nota.indicadetalhamento == 'S'">
                            <v-list-item class="table-siged-menu" >
                                <v-list-item-title  @click="setDetalhamentoNota(nota.identificadordistribuirnotas)">
                                  {{ (idExibirDetalhado > 0)? 'Inibir Detalhamento' : 'Exibir Detalhamento' }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item class="table-siged-menu" >
                                <v-list-item-title @click="showModalDetalhar({ acao: 'novo', identificadordistribuirnotas: nota.identificadordistribuirnotas })">
                                  Novo Detalhamento
                                </v-list-item-title>
                            </v-list-item>
                          </v-list>
                    </v-menu>
                  </th>
                  <th
                    :key="nota.id"
                    v-else-if="exibirDetalhamentoNota(nota) && idExibirDetalhado === 0 && !exibirProvasEspeciais"
                    rowspan="2"
                  >
                    <span :title="nota.descricaoatividadeavaliativa">
                      {{ nota.siglaatividadeavaliativa }}<br />
                      ({{ nota.valordistribuicao | formatNumber }} pts)<br />
                    </span>
                    <v-menu open-on-click offset-y left>
                      <template v-slot:activator="{ on }">
                        <v-btn dark icon v-if="nota.indicadetalhamento == 'S'">
                          <v-icon v-on="on" small color="#000">add</v-icon>
                        </v-btn>
                      </template>
                        <v-list class="text-center p-4" v-if="nota.indicadetalhamento == 'S'">
                          <v-list-item class="table-siged-menu" >
                              <v-list-item-title @click="showModalDetalhar({ acao: 'novo', identificadordistribuirnotas: nota.identificadordistribuirnotas })">
                                Novo Detalhamento
                              </v-list-item-title>
                          </v-list-item>
                        </v-list>
                    </v-menu>
                  </th>
                </template>

                <th v-if="exibirColunasNormais()" rowspan="2">Total Período</th>

                <!-- Recuperação -->
                <template v-for="recuperacao in notasRecuperacao[0]">
                  <th
                    v-if="exibirDetalhamentoNota(recuperacao) && !exibirProvasEspeciais"
                    :title="recuperacao.descricaoatividadeavaliativa"
                    :key="recuperacao.id"
                    :rowspan="(idExibirDetalhado > 0)? 1 : 2"
                  >
                    {{ recuperacao.siglaatividadeavaliativa }}
                    <br />
                    ({{ recuperacao.valordistribuicao | formatNumber }} pts)
                  </th>
                </template>
                <!-- <th v-if="exibirColunasRecuperacao()" rowspan="2">Recuperação do Período <i style="text-transform: none">(obs.:Nota da prova + Participação) </i></th> -->
                <th v-if="exibirColunasRecuperacao()" rowspan="2">Nota Final</th>
                <th v-if="enturmacao.length > 0" rowspan="2">Total Geral dos Períodos Avaliativos</th>

                <!-- Recuperação Especial -->
                <template v-for="especial in notasRecuperacaoEspecial[0]">

                  <th
                    v-if="exibirDetalhamentoNota(especial) && exibirProvasEspeciais"
                    :title="especial.descricaoatividadeavaliativa"
                    :key="especial.id"
                    :rowspan="(idExibirDetalhado > 0)? 1 : 2"
                  >
                    {{ especial.siglaatividadeavaliativa }}
                    <br />
                    ({{ especial.valordistribuicao | formatNumber }} pts)
                  </th>
                  <th :key="especial.id"
                  v-if="exibirProvasEspeciais"
                  >
                    {{ `Não fez ${especial.siglaatividadeavaliativa}?` }}
                  </th>
                </template>


                <th
                  v-if="exibirColunasEspecial() && exibirProvasEspeciais"
                  rowspan="2"
                >Resultado Final</th>
              </tr>

              <!-- Subtitulo do detalhamento de atividades -->
              <tr v-if="idExibirDetalhado > 0">
                <th
                  class="header-detalhado"
                  v-for="detalhe in atividadesDetalhado"
                  :key="detalhe.id"
                >
                  {{ detalhe.descricao }}  ({{ detalhe.valor | formatNumber }} pts)
                  <br />
                  <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-btn dark icon >
                          <v-icon v-on="on" small color="#000">more_vert</v-icon>
                        </v-btn>
                      </template>
                        <v-list class="text-center p-4" >
                          <v-list-item class="table-siged-menu" >
                              <v-list-item-title @click="showModalDetalhar({ acao: 'editar', identificadordistribuirnotas: detalhe.identificadordistribuirnotas, identificadordetalharatividade: detalhe.identificadordetalharatividade })">
                                Editar Detalhamento
                              </v-list-item-title>
                          </v-list-item>
                        </v-list>
                  </v-menu>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="enturmacao.length == 0">
                <td colspan="2">Turma não encontrada!</td>
              </tr>
              <tr v-for="(aluno, index) in enturmacao" :key="`aluno-${index}`">
                <!--<td class="column-fixed">foto</td> --->
                <td style="cursor: pointer; text-align: left;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: aluno.cdtipesc, cdescola: aluno.cdescola, numatalun: aluno.numatalun};" class="column-fixed">
                  <div v-if="aluno.situacao_fim !== null" style="background-color:skyblue;">{{aluno.nmaluno}} <span style="font-weight:bold;" v-if="(/PDI/.test(aluno.invalido)  && pdirecebelancamento == 'S')">- PDI</span></div>
                  <div v-else>{{aluno.nmaluno}} <span style="font-weight:bold;" v-if="(/PDI/.test(aluno.invalido)  && pdirecebelancamento == 'S')">- PDI</span></div>
                  <div style="font-size: 10px">
                    <i>
                      <strong>Dt. Enturmação:</strong>
                      {{ aluno.dtsitalun | formatDataBR }}
                    </i>
                    <!-- Henrique <i v-if="aluno.possuiTolerancia" style="margin-left: 10px"><strong>{{ aluno.invalido }}:</strong> {{ aluno.dtafastam | formatDataBR }}</i> -->
                    <i v-if="aluno.situacao_fim !== null" style="margin-left: 10px; background-color: gold;">
                      <strong>{{ aluno.invalido }}:</strong>
                      {{ aluno.dtafastam | formatDataBR }}
                    </i>
                  </div>
                </td>
                <!-- Henrique <td v-if="aluno.invalido !== null && !aluno.possuiTolerancia" :colspan="getColspanInvalido()" class="centro"> -->
                <td
                  v-if="(/PDI/.test(aluno.invalido) && pdirecebelancamento != 'S')"
                  :colspan="getColspanInvalido()"
                  class="centro"
                >
                  {{ aluno.invalido }}
                  <span
                    v-if="aluno.dtafastam !== null"
                  >- {{ aluno.dtafastam | formatDataBR }}</span>
                </td>
                <template v-else>
                  <!-- Notas Normais -->
                  <template v-for="(nota, coluna) in notasNormais[index]">
                    <td
                      :key="nota.id"
                      v-if="nota.primeiroDistribuicao && idExibirDetalhado === 0 && !exibirProvasEspeciais"
                      class="centro tamanho-colunas"
                    >{{ calculoDetalhado(index, nota.identificadordistribuirnotas) | formatNumber }}</td>
                    <td
                      v-if="exibirDetalhamentoNota(nota) && !exibirProvasEspeciais"
                      :key="nota.id"
                      class="centro tamanho-colunas"
                    >
                      <InputLancarNotas
                        class="input-notas"
                        v-bind="dadosInput"
                        :data-index="index"
                        :disabled="desabilitarCamposNormais()"
                        v-model.number="nota.valornota"
                        :identificadordistribuirnotas="nota.identificadordistribuirnotas"
                        :identificadordetalharatividade="nota.identificadordetalharatividade"
                        :valorDistribuicao="nota.valordistribuicao"
                        :valorDetalhe="nota.valornotadetalhadaatividade"
                        :numatalun="aluno.numatalun"
                        @click.native="event => onClickInput(event, index)"
                        @input="calcularNotas(index, nota.identificadordistribuirnotas)"
                        @addNota="event => addNotaNaLista(event, index, coluna, listaNotasNormais)"
                        :showErros="getErros(index, coluna, listaDeErrorsNotasNormais)"
                      />
                    </td>
                    <!-- :showErros="getErros(index, indexNormais)"
                    @itemNota="event => setNotas(event, index, indexNormais)"-->
                  </template>
                  <td
                    class="centro destaque-coluna tamanho-colunas"
                    v-if="exibirColunasNormais()"
                    :class="{ 'aluno-rec': !desabilitarCamposRecuperacao(index, 0) && hasntNullArray(index) }"
                  >{{ totalNormais[index] | formatNumber }}</td>

                  <!-- Recuperação -->
                  <template v-for="(recuperacao, coluna) in notasRecuperacao[index]">
                    <td
                      v-if="exibirDetalhamentoNota(recuperacao) && !exibirProvasEspeciais"
                      :key="recuperacao.id"
                      class="centro tamanho-colunas"
                    >
                      <InputLancarNotas
                        class="input-notas"
                        v-bind="dadosInput"
                        :data-index="index"
                        :disabled="desabilitarCamposRecuperacao(index, recuperacao)"
                        v-model.number="recuperacao.valornota"
                        :identificadordistribuirnotas="recuperacao.identificadordistribuirnotas"
                        :identificadordetalharatividade="recuperacao.identificadordetalharatividade"
                        :valorDistribuicao="recuperacao.valordistribuicao"
                        :valorDetalhe="recuperacao.valornotadetalhadaatividade"
                        :numatalun="aluno.numatalun"
                        @click.native="event => onClickInput(event, index)"
                        @input="calcularNotas(index)"
                        @addNota="event => addNotaNaLista(event, index, coluna, listaNotasRecuperacao)"
                        :showErros="getErros(index, coluna, listaDeErrorsNotasRecuperacao)"
                      />
                    </td>
                  </template>

                  <!-- <td class="centro destaque-coluna tamanho-colunas" v-if="exibirColunasRecuperacao()">{{ totalRecuperacao[index] | formatNumber }}</td> -->
                  <td
                    class="centro destaque-coluna tamanho-colunas"
                    v-if="exibirColunasRecuperacao()"
                    :class="{ 'aluno-rec': exibirCorAlunoRecuperacao(index) && hasntNullArray(index) }"
                  >{{ notaFinalPeriodo[index] | formatNumber }}</td>
                  <td
                    class="centro destaque-coluna tamanho-colunas"
                  >{{ totalGeralTodosPeriodos[index] | formatNumber}}</td>

                  <!-- Recuperação Especial -->
                  <template v-for="(especial, coluna) in notasRecuperacaoEspecial[index]">
                    <td
                      v-if="exibirDetalhamentoNota(especial) && exibirProvasEspeciais"
                      :key="especial.id"
                      class="centro tamanho-colunas"
                    >
                        <InputLancarNotas
                          class="input-notas"
                          v-bind="dadosInput"
                          :data-index="index"
                          :disabled="desabilitarCamposEspecial(index, coluna) || especial.indicanaofez"
                          v-model.number="especial.valornota"
                          :identificadordistribuirnotas="especial.identificadordistribuirnotas"
                          :identificadordetalharatividade="especial.identificadordetalharatividade"
                          :valorDistribuicao="especial.valordistribuicao"
                          :valorDetalhe="especial.valornotadetalhadaatividade"
                          :numatalun="aluno.numatalun"
                          :indicanaofez="especial.indicanaofez"
                          @click.native="event => onClickInput(event, index)"
                          @input="calcularNotas(index)"
                          @addNota="event => addNotaNaLista(event, index, coluna, listaNotasRecuperacaoEspecial)"
                          :showErros="getErros(index, coluna, listaDeErrorsNotasRecuperacaoEspecial)"
                        />
                    </td>
                    <td :key="especial.id"
                        class="centro tamanho-colunas"
                        v-if="exibirDetalhamentoNota(especial) && exibirProvasEspeciais"
                     >
                     <CheckBoxCustom
                        :trueValue="true"
                        :falseValue="false"
                        v-model="especial.indicanaofez"
                        :disabled="desabilitarCamposEspecial(index, coluna)"
                        :val="(especial.indicanaofez )? true :  false"
                        @input="
                          if (especial.indicanaofez) especial.valornota  = null
                          addNotaNaLista({
                                          aaletivo: especial.aaletivo,
                                          cdtipesc: parseInt(dadosInput.cdtipesc),
                                          cdescola: parseInt(dadosInput.cdescola),
                                          cdpessoal: parseInt(dadosInput.cdpessoal),
                                          cdmatric: parseInt(dadosInput.cdmatric),
                                          cdturma: dadosInput.cdturma,
                                          cddiscipl: dadosInput.disciplina,
                                          numatalun: aluno.numatalun,
                                          identificadordistribuirnotas: especial.identificadordistribuirnotas,
                                          identificadordetalharatividade: especial.identificadordetalharatividade,
                                          valor: especial.valornota,
                                          indicanaofez:  especial.indicanaofez
                                          },
                                          index, coluna, listaNotasRecuperacaoEspecial
                                        )

                           "
                      />
                    </td>
                  </template>
                  <td
                    :class="{ 'aluno-rec': exibirCorMediaFinal(index), 'centro destaque-coluna tamanho-colunas': true }"
                    v-if="exibirColunasEspecial() && exibirProvasEspeciais"
                  >{{ mediaFinal[index] | formatNumber }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </transition>
    </div>

    <DetalharAtividade
      ref="detalharAtividade"
      v-bind.sync="dadosModalDetalhar"
      :dialog.sync="exibirModalDetalhar"
      @retorno="reload"
    />

    <!-- <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
    </template>-->

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="550">
          <v-card>
            <v-card-title class="headline">Atenção</v-card-title>
            <v-card-text>Olá, identificamos que existem alterações nas notas que devem ser salvas. Você confirma essas alterações ?</v-card-text>
            <v-card-text>
              <v-spacer></v-spacer>
              <div class="btn-modal">
                <v-btn
                    class="rounded-sm font-weight-regular text-capitalize"
                    color
                    @click="handleCancelModalAvisoNotas()"
                >Descartar alterações</v-btn>
                <v-btn
                  class="rounded-sm font-weight-regular custom-transform-class text-none white--text"
                  color="teal"
                  :loading="loadingSaveNotas"
                  :disabled="loadingSaveNotas"
                  @click="handleModalSaveNotas()"
                >Ok, confirmo o lançamento das notas</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
      </v-snackbar>

    <ContatoAluno v-bind.sync="dadosContatoAluno" />
  </div>
</template>

<script>
import store from "@/store/index";
import InputLancarNotas from "@/components/InputLancarNotas";
import DetalharAtividade from "@/components/DetalharAtividade";
import InformacoesPromocaoPeriodos from "@/components/InformacoesPromocaoPeriodos";
import ContatoAluno from '@/components/ContatoAluno';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");
const PeriodoAvaliativoRepository = RepositoryFactory.get("periodoAvaliativo");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const buscarEnturmacao = async (dados) => {
  return await DiarioEscolarRepository.getEnturmacaoNotas({
    ...dados,
    ...dadosUser(),
  });
};

const saveListaNotas = async (listaNotas) => {
  return await DiarioEscolarRepository.saveListaNotas(listaNotas);
};

export default {
  name: "LancarNotas",
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    paginaAtualTurmas: [String, Number],
    cdinstruc: [Number],
  },
  components: {
    InputLancarNotas,
    DetalharAtividade,
    InformacoesPromocaoPeriodos,
    ContatoAluno,
  },
  data() {
    return {
      headers: [{ text: "Aluno", value: "nmaluno" }],
      listaDeErrorsNotasNormais: [],
      listaDeErrorsNotasRecuperacao: [],
      listaDeErrorsNotasRecuperacaoEspecial: [],

      listaNotasNormais: [],
      listaNotasRecuperacao: [],
      listaNotasRecuperacaoEspecial: [],
      listaDeAlunosComNotasPendentes: [],

      submitText: "",
      snackbar: false,
      dialog: false,
      router_leave: null,
      loadingSaveNotas: false,
      retornarParaATelaInicial: false,
      isReload: true,

      sumiu: true,
      periodoSelecionado: "",
      periodoSelecionadoOld: "",
      diarioAberto: false,
      loading: false,
      linhaX: 0,
      linhaY: 0,
      periodosAvaliativos: [],
      enturmacao: [],
      notasNormais: [],
      totalNormais: [],
      notasRecuperacao: [],
      totalRecuperacao: [],
      notaFinalPeriodo: [],
      notasRecuperacaoEspecial: [],
      mediaFinal: [],
      resultadoEOP: [],
      idExibirDetalhado: 0,
      atividadesDetalhado: [],
      totalGeralPeriodos: [],
      totalGeralTodosPeriodos: [],
      quantidadeDetalhado: 0,
      dadosInput: {
        ano: this.ano,
        cdturma: this.cdturma,
        disciplina: this.disciplina,
        ...dadosUser(),
      },
      exibirModalDetalhar: false,
      exibirProvasEspeciais: false,
      dadosModalDetalhar: {},
      valorPromocao: 0,
      valoresPromocaoPeriodo: [],
      msgError: "",
      aaletivo: this.ano,
      codinstruc: this.cdinstruc,
      dadosContatoAluno: {},
      pdirecebelancamento: ''
    };
  },
  watch: {
    periodoSelecionado: {
      handler: function (newVal, oldVal) {
        if (this.dialog) {
          if (oldVal !== null && oldVal != "") {
            this.periodoSelecionadoOld = String(oldVal);
          }
        } else {
          this.periodoSelecionadoOld = this.periodoSelecionado;
        }
      },
    },
  },
  async beforeRouteEnter(to, from, next) {
    if (
      typeof to.params.ano === "undefined" ||
      typeof to.params.cdturma === "undefined" ||
      typeof to.params.disciplina === "undefined"
    ) {
      return next("/diario-escolar");
    }
    try {
      const { cdtipesc, cdescola } = dadosUser();
      const dadosTurma = {
        aaletivo: to.params.ano,
        cdtipesc,
        cdescola,
        cdturma: to.params.cdturma,
        cdinstruc: to.params.cdinstruc,
      };

      const periodo = await PeriodoAvaliativoRepository.getPeriodoTurmas(
        dadosTurma
      );
      const formatedPeriodo = periodo.data.results.map((key) => ({
        value: key.cdpravadi,
        text: key.dspravadi,
      }));

      const promocaoPorPeriodo = await PeriodoAvaliativoRepository.getValoresPromocaoPeriodo(
        dadosTurma
      );

      const { data } = await buscarEnturmacao({
        aaletivo: to.params.ano,
        cdturma: to.params.cdturma,
        cddiscipl: to.params.disciplina,
      });

      next((vm) => {
        vm.montarPeriodoAvaliativo(formatedPeriodo);
        vm.montarCabecalhoPeriodo(promocaoPorPeriodo.data.results);
        vm.reload(data);
      });
    } catch (e) {
      return next("/diario-escolar");
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (sessionStorage.httpStatusCode) {
      next();
    }
    const existeNotasParaSalvar = this.getExisteNotasPendenteParaSalvar([
      ...this.listaNotasNormais,
      ...this.listaNotasRecuperacao,
      ...this.listaNotasRecuperacaoEspecial,
    ]);

    if (existeNotasParaSalvar) {
      this.listaDeAlunosComNotasPendentes = this.listaNotasNormais.filter(
        (aluno) => aluno.some((nota) => nota !== null)
      );
      this.dialog = true;

      if (from.fullPath !== to.fullPath) {
        this.router_leave = to.fullPath;
      }

      next(false);
    } else {
      this.dialog = false;
      next();
    }
  },
  created() {
    document.addEventListener("keyup", this.onKeyUp);
  },
  destroyed() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  methods: {
    initListas(listaNotaModelo, listaNotas, listaErros) {
      for (const aluno in listaNotaModelo) {
        listaNotas[aluno] = [];
        listaErros[aluno] = [];
        listaNotaModelo[aluno].forEach((nota, index) => {
          listaNotas[aluno][index] = null;
          listaErros[aluno][index] = null;
        });
      }
    },
    getExisteNotasPendenteParaSalvar([...listaNotas]) {
      let exists = false;
      for (let index in listaNotas) {
        exists = listaNotas[index].some((nota) => nota !== null)   ;
        if (exists) {
          break;
        }
      }
      return exists;
    },
    resetListaDeNotas(listaNotaModelo, listaNotas) {
      for (const aluno in listaNotaModelo) {
        listaNotas[aluno] = [];
        listaNotaModelo[aluno].forEach((nota, index) => {
          listaNotas[aluno][index] = null;
        });
      }
    },
    removeNotasDosAlunosComPendencias(listaNotas, listaDeErros) {
      for (const aluno in listaNotas) {
        listaDeErros[aluno].forEach((nota, index) => {
          if (nota !== null && "errors" in nota) {
            listaNotas[aluno][index] = null;
          }
        });
      }
    },
    setListaDeErrors(listaNotas, listaErros) {
      for (const aluno in listaNotas) {
        listaNotas[aluno].forEach((nota, index) => {
          if (nota !== null && "errors" in nota) {
            listaErros[aluno][index] = {};
            listaErros[aluno][index]["errors"] = nota.errors;
          }
        });
      }
    },
    getErros(linha, coluna, listaDeErros) {
      let error = [];
      if (
        listaDeErros[linha][coluna] !== null &&
        "errors" in listaDeErros[linha][coluna]
      ) {
        error.push(listaDeErros[linha][coluna].errors);
      }

      return error;
    },
    addNotaNaLista(nota, linha, coluna, listaNotas) {
      listaNotas[linha][coluna] = nota;
    },
    actionModal() {
      if (this.router_leave) {
        this.$router.push({ path: this.router_leave, params: {} });
      }
      if (this.isReload) {
        this.reload();
      }
    },
    handleModalSaveNotas() {
      this.retornarParaATelaInicial = false;
      this.handleSaveNotas();
    },
    handleCancelModalAvisoNotas() {
      this.resetListaDeNotas(this.notasNormais, this.listaNotasNormais);
      this.resetListaDeNotas(this.notasRecuperacao, this.listaNotasRecuperacao);
      this.resetListaDeNotas(
        this.notasRecuperacaoEspecial,
        this.listaNotasRecuperacaoEspecial
      );
      this.dialog = false;
      this.actionModal();
    },
    async handleSaveNotas() {
      try {
        this.removeNotasDosAlunosComPendencias(
          this.listaNotasNormais,
          this.listaDeErrorsNotasNormais
        );
        this.removeNotasDosAlunosComPendencias(
          this.listaNotasRecuperacao,
          this.listaDeErrorsNotasRecuperacao
        );
        this.removeNotasDosAlunosComPendencias(
          this.listaNotasRecuperacaoEspecial,
          this.listaDeErrorsNotasRecuperacaoEspecial
        );
        this.loadingSaveNotas = true;

        let existeNotasNormaisParaSalvar = false;
        for (let index in this.listaNotasNormais) {
          existeNotasNormaisParaSalvar = this.listaNotasNormais[index].some(
            (nota) => nota !== null
          );
          if (existeNotasNormaisParaSalvar) {
            break;
          }
        }

        let existeNotasRecuperacao = false;
        for (let index in this.listaNotasRecuperacao) {
          existeNotasRecuperacao = this.listaNotasRecuperacao[index].some(
            (nota) => nota !== null
          );
          if (existeNotasRecuperacao) {
            break;
          }
        }

        let existeNotasRecuperacaoEspecial = false;
        for (let index in this.listaNotasRecuperacaoEspecial) {
          existeNotasRecuperacaoEspecial = this.listaNotasRecuperacaoEspecial[
            index
          ].some((nota) => nota !== null);
          if (existeNotasRecuperacaoEspecial) {
            break;
          }
        }

        const results = await Promise.all([
          existeNotasNormaisParaSalvar
            ? saveListaNotas({
                type: "notas_normais",
                data: this.listaNotasNormais,
                aaletivo: this.aaletivo,
                cdinstruc: this.cdinstruc
              })
            : null,
          existeNotasRecuperacao
            ? saveListaNotas({
                type: "notas_recuperacao",
                data: this.listaNotasRecuperacao,
                aaletivo: this.aaletivo,
                cdinstruc: this.cdinstruc
              })
            : null,
          existeNotasRecuperacaoEspecial
            ? saveListaNotas({
                type: "notas_recuperacao_especial",
                data: this.listaNotasRecuperacaoEspecial,
                aaletivo: this.aaletivo,
                cdinstruc: this.cdinstruc
              })
            : null,
        ]);

        const resultsFiltred = results.filter((response) => response !== null);

        if (resultsFiltred.length === 0) {
          this.submitText = "Dados salvos com sucesso!";
          this.snackbar = true;
        }

        for (let index in resultsFiltred) {
          const { result, message } = resultsFiltred[index].data;
          const { type, data } = result;
          this.submitText = message;
          this.snackbar = true;
          switch (type) {
            case "notas_normais":
              this.setListaDeErrors(data, this.listaDeErrorsNotasNormais);
              break;
            case "notas_recuperacao":
              this.setListaDeErrors(data, this.listaDeErrorsNotasRecuperacao);
              break;
            case "notas_recuperacao_especial":
              this.setListaDeErrors(
                data,
                this.listaDeErrorsNotasRecuperacaoEspecial
              );
              break;
            default:
              break;
          }
        }
        // this.submitText = response.data.message;
        // this.snackbar = true;
        // }
      } catch (error) {
      } finally {
        this.loadingSaveNotas = false;
        this.periodoSelecionado =
          this.periodoSelecionado != this.periodoSelecionadoOld &&
          this.periodoSelecionadoOld != ""
            ? this.periodoSelecionadoOld
            : this.periodoSelecionado;
        this.dialog = false;

        this.resetListaDeNotas(this.notasNormais, this.listaNotasNormais);
        this.resetListaDeNotas(
          this.notasRecuperacao,
          this.listaNotasRecuperacao
        );
        this.resetListaDeNotas(
          this.notasRecuperacaoEspecial,
          this.listaNotasRecuperacaoEspecial
        );
      }
    },
    clickEspecial() {
      this.sumiu = false;
      setTimeout((key) => (this.sumiu = true), 300);
    },
    montarCabecalhoPeriodo(valoresPeriodo) {
      this.valoresPromocaoPeriodo = valoresPeriodo;
    },

    async changePeriodoAvaliativo() {
      this.isReload = true;
      this.router_leave = null;
      const existeNotasParaSalvar = this.getExisteNotasPendenteParaSalvar([
        ...this.listaNotasNormais,
        ...this.listaNotasRecuperacao,
        ...this.listaNotasRecuperacaoEspecial,
      ]);
      if (existeNotasParaSalvar) {
        this.listaDeAlunosComNotasPendentes = this.listaNotasNormais.filter(
          (aluno) => aluno.some((nota) => nota !== null)
        );
        this.dialog = true;
      } else {
        this.reload();
      }
    },
    async reload(data = null) {
      this.loading = true;
      this.sumiu = false;
      this.msgError = "";
      if (!data) {
        this.$Progress.start();
        const response = await buscarEnturmacao({
          aaletivo: this.ano,
          cdturma: this.cdturma,
          cddiscipl: this.disciplina,
          cdpravadi: this.periodoSelecionado,
        });
        data = response.data;
      }

      if (data.errorMessage) {
        this.msgError = data.errorMessage;
        this.$Progress.finish();
        return;
      }

      this.enturmacao = [...data.results.alunos];
      this.diarioAberto = data.results.aberto;
      this.valorPromocao = data.results.valor_promocao;
      this.pdirecebelancamento = data.results.pdi_avaliado;
      this.resultadoEOP = [];

      for (let alunoIndex in this.enturmacao) {
        let auxDistribuido = 0;
        this.enturmacao[alunoIndex].distribuir_notas.map((key) => {
          if (
            key.identificadordistribuirnotas > 0 &&
            key.identificadordetalharatividade > 0 &&
            key.identificadordistribuirnotas != auxDistribuido
          ) {
            key.primeiroDistribuicao = true;
            auxDistribuido = key.identificadordistribuirnotas;
          } else {
            key.primeiroDistribuicao = false;
          }
          return key;
        });
        this.notasNormais[alunoIndex] = this.filtrarAtividade(
          this.enturmacao[alunoIndex].distribuir_notas,
          "N"
        );
        this.notasRecuperacao[alunoIndex] = this.filtrarAtividade(
          this.enturmacao[alunoIndex].distribuir_notas,
          "R"
        );
        this.notasRecuperacaoEspecial[alunoIndex] = this.filtrarAtividade(
          this.enturmacao[alunoIndex].distribuir_notas,
          "E"
        );
        this.totalGeralPeriodos[alunoIndex] = this.enturmacao[
          alunoIndex
        ].total_periodos;
        this.totalGeralTodosPeriodos[alunoIndex] = 0;

        this.calcularNotas(alunoIndex);
      }

      this.quantidadeDetalhado = this.enturmacao[0].distribuir_notas.filter(
        (key) => key.identificadordetalharatividade !== null
      ).length;

      this.idExibirDetalhado = 0;
      this.atividadesDetalhado = [];
      this.$Progress.finish();
      this.loading = false;
      this.exibirProvasEspeciais = false;

      this.initListas(
        this.notasNormais,
        this.listaNotasNormais,
        this.listaDeErrorsNotasNormais
      );
      this.initListas(
        this.notasRecuperacao,
        this.listaNotasRecuperacao,
        this.listaDeErrorsNotasRecuperacao
      );
      this.initListas(
        this.notasRecuperacaoEspecial,
        this.listaNotasRecuperacaoEspecial,
        this.listaDeErrorsNotasRecuperacaoEspecial
      );

      setTimeout(() => (this.sumiu = true), 500);
    },
    montarPeriodoAvaliativo(periodo) {
      if (periodo.length <= 0) {
        return;
      }
      this.periodosAvaliativos = periodo;
      this.periodoSelecionado = periodo[0].value;
    },
    filtrarAtividade(dados, tipo) {
      return dados.filter((key) => key.indicaatividade === tipo);
    },
    calcularNotas(index) {
      this.totalNormais[index] = this.notasNormais[index].reduce(
        (total, valor) => parseFloat( (total + (valor.valornota || 0)).toFixed(2) ),
        0
      );
      this.totalGeralTodosPeriodos[index] = this.totalGeralPeriodos[index];

      if (
        this.notasRecuperacao.length > 0 &&
        this.notasRecuperacao[0].length > 0
      ) {
        // const participacao = this.notasNormais[index].filter(key => key.descricaoatividadeavaliativa.replace(' ', '').toLowerCase() === 'participação').reduce((total, valor) => (valor.valornota || 0), 0);
        this.totalRecuperacao[index] = this.notasRecuperacao[index].reduce(
          (total, valor) => total + (valor.valornota || 0),
          0
        );

        // if(this.totalRecuperacao[index] > 0) { this.totalRecuperacao[index] += participacao; }

        this.notaFinalPeriodo[index] =
          this.totalRecuperacao[index] > this.totalNormais[index]
            ? this.totalRecuperacao[index]
            : this.totalNormais[index];
        this.totalGeralTodosPeriodos[index] += this.notaFinalPeriodo[index];
      } else {
        this.totalGeralTodosPeriodos[index] += this.totalNormais[index];
      }

      this.resultadoEOP[index] = 0;
      /* const EOP = this.notasRecuperacaoEspecial[index].find(key => key.siglaatividadeavaliativa === 'EOP');
      if(EOP && EOP.valornota !== null) {
        this.resultadoEOP[index] = (this.totalGeralTodosPeriodos[index] / 2) + (EOP.valornota || 0);
      } */

      let totalEspecial =
        this.resultadoEOP[index] +
        this.notasRecuperacaoEspecial[index].reduce((total, valor) => {
          // if (valor.siglaatividadeavaliativa !== 'EOP') { total += (valor.valornota || 0); }
          total += valor.valornota || 0;
          return total;
        }, 0);

      if (totalEspecial === 0) {
        this.mediaFinal[index] =
          this.totalGeralTodosPeriodos[index] === 0
            ? "-"
            : this.totalGeralTodosPeriodos[index];
      } else {
        // const media = this.totalGeralTodosPeriodos[index] + totalEspecial;
        // this.mediaFinal[index] = (media >= this.valorPromocao)? this.valorPromocao : media;
        totalEspecial =
          this.totalGeralTodosPeriodos[index] > totalEspecial
            ? this.totalGeralTodosPeriodos[index]
            : totalEspecial;
        // this.mediaFinal[index] = (totalEspecial >= this.valorPromocao)? this.valorPromocao : totalEspecial;
        this.mediaFinal[index] = totalEspecial;
      }
    },
    calculoDetalhado(alunoIndex, idDistribuirNotas) {
      let valorTotalDetalhado = 0;
      valorTotalDetalhado += this.notasNormais[alunoIndex]
        .filter((key) => key.identificadordistribuirnotas === idDistribuirNotas)
        .reduce((total, valor) => total + (valor.valornota || 0), 0);

      return valorTotalDetalhado;
    },
    getColspanInvalido() {
      let countColspan = 1;
      if (this.exibirColunasNormais()) {
        countColspan += this.notasNormais[0].length + 1;
      }
      if (this.exibirColunasRecuperacao()) {
        countColspan += this.notasRecuperacao[0].length + 1;
      }
      if (this.exibirColunasEspecial() && this.exibirProvasEspeciais) {
        countColspan += this.notasRecuperacaoEspecial[0].length + 2;
      }
      if (this.atividadesDetalhado.length > 0) {
        countColspan += this.atividadesDetalhado.length;
      } else {
        countColspan -= this.quantidadeDetalhado;
        countColspan += this.notasNormais[0].reduce((total, value) => {
          if (
            value.identificadordetalharatividade !== null &&
            total.indexOf(value.identificadordistribuirnotas) < 0
          ) {
            total.push(value.identificadordistribuirnotas);
          }
          return total;
        }, []).length;
      }
      return countColspan;
    },
    desabilitarCamposNormais() {
      return !this.diarioAberto;
    },
    desabilitarCamposRecuperacao(index, recuperacao) {
      const { valorPromocao } = this.valoresPromocaoPeriodo.find(
        (key) => key.cdpravadi === this.periodoSelecionado
      );
      if (typeof valorPromocao === "undefined") {
        return true;
      }

      return (
        this.desabilitarCamposNormais() ||
        this.totalNormais[index] >= valorPromocao
      );
    },
    desabilitarCamposEspecial(index, especialIndex) {
      let valorEspecialAnteriores = 0;
      for (let i = 0; i < especialIndex; i++) {
        valorEspecialAnteriores +=
          this.notasRecuperacaoEspecial[index][i].valornota || 0;
      }
      return (
        this.desabilitarCamposNormais() ||
        this.totalGeralTodosPeriodos[index] >= this.valorPromocao ||
        valorEspecialAnteriores >= this.valorPromocao
      );
    },
    exibirColunasNormais() {
      return (
        this.notasNormais.length > 0 &&
        this.notasNormais[0].length > 0 &&
        this.idExibirDetalhado === 0 &&
        !this.exibirProvasEspeciais
      );
    },
    exibirColunasRecuperacao() {
      return (
        this.notasRecuperacao.length > 0 &&
        this.notasRecuperacao[0].length > 0 &&
        this.idExibirDetalhado === 0 &&
        !this.exibirProvasEspeciais
      );
    },
    exibirColunasEspecial() {
      return (
        this.notasRecuperacaoEspecial.length > 0 &&
        this.notasRecuperacaoEspecial[0].length > 0 &&
        this.idExibirDetalhado === 0
      );
    },
    onKeyUp(key) {
      let rowX = this.linhaX;
      let rowY = this.linhaY;
      let fim = this.enturmacao.length;

      switch (key.keyCode) {
        case 37:
          rowY--;
          fim = rowX + 1;
          break;
        case 38:
          rowX--;
          fim = 0;
          break;
        case 39:
          rowY++;
          fim = rowX + 1;
          break;
        case 40:
          rowX++;
          break;
        default:
          return;
      }

      let items = [];
      for (
        rowX;
        (rowX >= 0 && rowX <= fim) || (key.keyCode == 38 && rowX > fim);
        rowX = key.keyCode == 38 ? rowX - 1 : rowX + 1
      ) {
        items = document.querySelectorAll(`.input-notas[data-index="${rowX}"]`);
        if (items.length > 0) {
          break;
        }
      }
      if (typeof items[rowY] === "undefined") {
        return;
      }

      this.linhaX = rowX;
      this.linhaY = rowY;

      let input = items[rowY].firstElementChild;
      input.focus();

      // if(key.keyCode)
    },
    onClickInput(event, rowX) {
      this.linhaX = rowX;
      const items = document.querySelectorAll(
        `.input-notas[data-index="${rowX}"]`
      );
      for (const [index, item] of items.entries()) {
        if (item.firstElementChild === event.target) {
          return (this.linhaY = index);
        }
      }
    },
    setDetalhamentoNota(id) {
      this.sumiu = false;
      if (this.idExibirDetalhado === 0) {
        this.idExibirDetalhado = id;
        this.atividadesDetalhado = this.notasNormais[0]
          .filter(
            (key) => key.identificadordistribuirnotas === this.idExibirDetalhado
          )
          .map((key) => ({
            descricao: key.descricaodetalhada,
            valor: key.valornotadetalhadaatividade || 0,
            identificadordetalharatividade: key.identificadordetalharatividade,
            identificadordistribuirnotas: key.identificadordistribuirnotas,
          }));
      } else {
        this.idExibirDetalhado = 0;
        this.atividadesDetalhado = [];
      }
      setTimeout(() => (this.sumiu = true), 500);
    },
    exibirDetalhamentoNota(data) {
      return (
        (this.idExibirDetalhado === 0 &&
          data.identificadordetalharatividade === null) ||
        this.idExibirDetalhado === data.identificadordistribuirnotas
      );
    },
    showModalDetalhar(data) {
      this.dadosModalDetalhar = {
        ...data,
        aaletivo: this.ano,
        cdturma: this.cdturma,
        cddiscipl: this.disciplina,
        ...dadosUser(),
      };
      setTimeout(() => {}, 500);
      this.$refs.detalharAtividade.abrirModal(this.dadosModalDetalhar);
      this.exibirModalDetalhar = true;
    },
    btnArrowBack() {
      this.retornarParaATelaInicial = true;
      this.isReload = false;

      if (this.idExibirDetalhado > 0) {
        this.setDetalhamentoNota(0);
      } else {
        this.$router.push({
          name: "diario-escolar",
          params: { paginaAtualTurmas: this.paginaAtualTurmas },
        });
      }
    },
    exibirCorAlunoRecuperacao(index) {
      const { valorPromocao } = this.valoresPromocaoPeriodo.find(
        (key) => key.cdpravadi === this.periodoSelecionado
      );
      return this.notaFinalPeriodo[index] < valorPromocao;
    },
    exibirCorResultadoEOP(index) {
      return (
        this.resultadoEOP[index] > 0 &&
        this.resultadoEOP[index] < this.valorPromocao
      );
    },
    exibirCorMediaFinal(index) {
      return (
        this.mediaFinal[index] !== "-" &&
        this.mediaFinal[index] < this.valorPromocao
      );
    },
    hasntNullArray(index) {
      return this.notasNormais[index].some((key) => key.valornota !== null);
    },
    hasEOP(dados) {
      return dados.siglaatividadeavaliativa === "EOP";
    },
  },
};
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
  .v-btn {
    width: 100%;

  }
}

.lancar-notas {
  .destaque-coluna {
    background: #cfd8dc;
  }

  .tamanho-colunas {
    width: 100px;
  }
}

.aluno-rec {
  color: red;
}

.lancar-notas-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;

  .lancar-notas-header-select {
    width: 300px;
  }

  .lancar-notas-header-info {
    width: 600px;
    justify-content: end;
  }
}

.fixed {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 4;

  th {
    position: -webkit-sticky;
    position: sticky;
    top: -1px;
    z-index: 4;
    background: white;
  }

  .header-detalhado {
    top: 67px !important;
  }
}

td,
th {
  margin: 0;
}

.column-fixed {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 3;
  // background: white;
}

.table-overflow {
  overflow-y: auto;
  position: relative;
  max-height: 600px;

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.14);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }
}

@media only screen and (max-width: 500px) {
  .lancar-notas-header {
    .lancar-notas-header-select,
    .lancar-notas-header-info {
      width: 100%;
    }
  }
}
</style>
